{
  "title": "如何重新開放評分",
  "description": "讓評審已鎖定的分數可以重新修改。",
  "headings": [
    "你會完成什麼",
    "適用角色",
    "操作前確認",
    "操作路徑",
    "操作步驟",
    "完成後",
    "警告",
    "常見問題"
  ],
  "summary": "完成後，指定評審針對該筆投稿的分數會解除鎖定，評審可以重新修改並再次正式送出。",
  "roleNote": "具 score.manage 權限的競賽管理員",
  "prerequisites": ["該筆投稿已有評審送出並鎖定分數", "已確認需要重新開放的具體理由"],
  "pathLabel": "主辦方後台 → 投稿管理 → 投稿詳情 → 分數區塊",
  "steps": [
    {
      "title": "1. 開啟投稿詳情",
      "description": "在「投稿管理」找到該筆投稿，點開進入「投稿詳情」頁。"
    },
    { "title": "2. 找到已鎖定的分數", "description": "在分數區塊找到該位評審已鎖定的分數。" },
    { "title": "3. 點選「重新開放」", "description": "點選「重新開放」，填寫必填的理由後確認。" }
  ],
  "afterward": ["該筆分數解除鎖定", "評審可重新修改並再次正式送出", "系統建立稽核紀錄與修改歷程"],
  "warning": "重新開放不會覆蓋原始分數，但會建立可回溯的修改歷程；請先確認理由再操作。",
  "nextSteps": "評審重新送出分數後，會再次回到鎖定狀態，可視需要重新計算成績。",
  "faq": [
    {
      "q": "重新開放後，原本的分數會不見嗎？",
      "a": "不會。原始分數與修改歷程都會保留在稽核紀錄中，重新開放只是讓評審可以再次修改並送出新的分數。"
    }
  ]
}
